import { IApplicationState } from '../types/redux';

export const selectIsStickyBtnVisible = (state: IApplicationState) => state.page.isStickyBtnVisible;
